import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BetSlip } from 'pages/BetSlip';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { usePlayerLayout } from 'lib/playerLayout';
import { closeSlipSheet, useSlipSheetOpen } from 'lib/slipSheet';

/**
 * Modern layout on a phone: the bet slip as a sheet over the page it was
 * opened from. Going to another page closes it.
 */
export const ModernSlipSheet = () => {
  const open = useSlipSheetOpen();
  const { pathname } = useLocation();
  const { isMobile } = useBreakpoint();
  const modern = usePlayerLayout() === 'modern';

  useEffect(() => {
    closeSlipSheet();
  }, [pathname]);

  if (!open || !isMobile || !modern) return null;
  return <BetSlip onClose={closeSlipSheet} />;
};
